import { FC } from 'react';

type BatteryChargeIconProps = {
    color?: 'red' | 'amber' | 'yellow' | 'green';
    width?: number;
    height?: number;
    className?: string;
};

export const BatteryChargeIcon: FC<BatteryChargeIconProps> = ({ color, height = 13, width = 24, className }) => {
    if (!color || color === 'red') {
        return (
            <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 8.70884C22.0875 8.70884 21.75 8.37134 21.75 7.95884V4.45728C21.75 4.04478 22.0875 3.70728 22.5 3.70728C22.9125 3.70728 23.25 4.04478 23.25 4.45728V7.95884C23.25 8.37602 22.9125 8.70884 22.5 8.70884Z"
                    fill="#FF4863"
                />
                <path
                    d="M18.1078 12.2104H3.64219C2.04844 12.2104 0.75 10.912 0.75 9.31826V3.10264C0.75 1.50889 2.04844 0.210449 3.64219 0.210449H18.1078C19.7016 0.210449 21 1.50889 21 3.10264V9.31826C21 10.912 19.7016 12.2104 18.1078 12.2104ZM3.64219 1.71045C2.87344 1.71045 2.25 2.33389 2.25 3.10264V9.31826C2.25 10.087 2.87344 10.7104 3.64219 10.7104H18.1078C18.8766 10.7104 19.5 10.087 19.5 9.31826V3.10264C19.5 2.33389 18.8766 1.71045 18.1078 1.71045H3.64219Z"
                    fill="#FF4863"
                />
            </svg>
        );
    }

    if (color === 'amber') {
        return (
            <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 8.70884C22.0875 8.70884 21.75 8.37134 21.75 7.95884V4.45728C21.75 4.04478 22.0875 3.70728 22.5 3.70728C22.9125 3.70728 23.25 4.04478 23.25 4.45728V7.95884C23.25 8.37602 22.9125 8.70884 22.5 8.70884Z"
                    fill="#FF9500"
                />
                <path
                    d="M18.1078 12.2104H3.64219C2.04844 12.2104 0.75 10.912 0.75 9.31826V3.10264C0.75 1.50889 2.04844 0.210449 3.64219 0.210449H18.1078C19.7016 0.210449 21 1.50889 21 3.10264V9.31826C21 10.912 19.7016 12.2104 18.1078 12.2104ZM3.64219 1.71045C2.87344 1.71045 2.25 2.33389 2.25 3.10264V9.31826C2.25 10.087 2.87344 10.7104 3.64219 10.7104H18.1078C18.8766 10.7104 19.5 10.087 19.5 9.31826V3.10264C19.5 2.33389 18.8766 1.71045 18.1078 1.71045H3.64219Z"
                    fill="#FF9500"
                />
                <rect x="3.41016" y="3.05249" width="4.8" height="6.31579" rx="1" fill="#FF9500" />
            </svg>
        );
    }

    if (color === 'yellow') {
        return (
            <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M22.5 8.70884C22.0875 8.70884 21.75 8.37134 21.75 7.95884V4.45728C21.75 4.04478 22.0875 3.70728 22.5 3.70728C22.9125 3.70728 23.25 4.04478 23.25 4.45728V7.95884C23.25 8.37602 22.9125 8.70884 22.5 8.70884Z"
                    fill="#FFD900"
                />
                <path
                    d="M18.1078 12.2104H3.64219C2.04844 12.2104 0.75 10.912 0.75 9.31826V3.10264C0.75 1.50889 2.04844 0.210449 3.64219 0.210449H18.1078C19.7016 0.210449 21 1.50889 21 3.10264V9.31826C21 10.912 19.7016 12.2104 18.1078 12.2104ZM3.64219 1.71045C2.87344 1.71045 2.25 2.33389 2.25 3.10264V9.31826C2.25 10.087 2.87344 10.7104 3.64219 10.7104H18.1078C18.8766 10.7104 19.5 10.087 19.5 9.31826V3.10264C19.5 2.33389 18.8766 1.71045 18.1078 1.71045H3.64219Z"
                    fill="#FFD900"
                />
                <rect x="3.41016" y="3.05249" width="9.85263" height="6.31579" rx="1" fill="#FFD900" />
            </svg>
        );
    }

    return (
        <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22.5 8.70884C22.0875 8.70884 21.75 8.37134 21.75 7.95884V4.45728C21.75 4.04478 22.0875 3.70728 22.5 3.70728C22.9125 3.70728 23.25 4.04478 23.25 4.45728V7.95884C23.25 8.37602 22.9125 8.70884 22.5 8.70884Z"
                fill="#00E58E"
            />
            <path
                d="M18.1078 12.2104H3.64219C2.04844 12.2104 0.75 10.912 0.75 9.31826V3.10264C0.75 1.50889 2.04844 0.210449 3.64219 0.210449H18.1078C19.7016 0.210449 21 1.50889 21 3.10264V9.31826C21 10.912 19.7016 12.2104 18.1078 12.2104ZM3.64219 1.71045C2.87344 1.71045 2.25 2.33389 2.25 3.10264V9.31826C2.25 10.087 2.87344 10.7104 3.64219 10.7104H18.1078C18.8766 10.7104 19.5 10.087 19.5 9.31826V3.10264C19.5 2.33389 18.8766 1.71045 18.1078 1.71045H3.64219Z"
                fill="#00E58E"
            />
            <rect x="3.41016" y="3.05249" width="14.9053" height="6.31579" rx="1" fill="#00E58E" />
        </svg>
    );
};
